// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__21JyS","footer":"ModalFilter_footer__19bsE"};